<template>
    <el-card shadow="never">
      <template #header>
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
            <el-breadcrumb-item>订单列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <el-form :model="searchForm" inline label-width="120px">
        <el-form-item label="分享人ID">
          <el-input v-model="searchForm.memberid" placeholder=""/>
        </el-form-item>
        <el-form-item label="公司">
          <el-select
              v-model="searchForm.companyid"
              placeholder="请选择"
              style="width: 240px"
              >
              <el-option
                  v-for="item in baseData.companylist"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
              />
              </el-select>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input v-model="searchForm.words" placeholder="公司|备注"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="ID" width="60"/>
          <el-table-column label="分享人" width="160">
            <template #default="scope">
              {{ scope.row.nickname }} (ID:{{ scope.row.memberid }})
          </template>
          </el-table-column>
          <el-table-column prop="company" label="公司"/>
          <el-table-column prop="total" label="价格（元）" width="160"/>
          <el-table-column prop="remark" label="备注" width="240"/>
          <el-table-column prop="created_at" label="创建时间" width="160"/>
          <el-table-column label="状态" width="100">
            <template #default="scope">
                <p v-if="scope.row.status == 1">待支付</p>
                <p v-if="scope.row.status == 2">已支付</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100" >
            <template #default="scope">
              <el-popconfirm
                v-if="scope.row.status == 1"
                confirm-button-text="Yes"
                cancel-button-text="No"
                title="你确定要改成支付状态?"
                @confirm="changeStatus(scope.row.id,2)"
              >
                <template #reference>
                    <el-button size="small" type="success">已支付</el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
    </el-card>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  const searchForm = reactive({
    memberid:'',
    companyid:'',
    words:'',
    limit:10,
    page:1,
  })
  const baseData:any = reactive({
    companylist:[],
    loading:false,
    title:'',
    userbox:false,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    baseData.loading = true
    api.orderApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const changeStatus = (id:number,status:number) => {
    baseData.loading = true
    api.orderApi.changeStatus({id:id,status:status}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getCompanyList = () => {
    baseData.loading = true
    api.companyApi.list({limit:10000,page:1}).then((res:any)=>{
      baseData.loading = false
      let companylist = []
      if(res.code==200){
        for(var i in res.data.list){
            if(res.data.list[i].status==1){
                companylist.push(res.data.list[i])
            }
        }
        baseData.companylist = companylist
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const search = () => {
    searchForm.page = 1
    getList()
  }
  const reset = () => {
    searchForm.page = 1
    searchForm.limit = 10
    searchForm.words = ""
    searchForm.companyid = ""
    getList()
  }
  onMounted(() => {
    getList()
    getCompanyList()
  })
  </script>